class FloatingVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('.section-with-floating-text__video-play-button');
    this.floatingTexts = document.querySelectorAll('.section-with-floating-text__item');
  }

  connectedCallback() {
    this.playButton.addEventListener('click', () => {
      this.video.play();
    });

    this.video.addEventListener('click', () => {
      if (!this.video.paused) {
        this.video.pause();
      }
    });

    this.video.addEventListener('pause', () => {
      this.updateButtonVisibility();
    });

    this.video.addEventListener('play', () => {
      this.updateButtonVisibility();
    });

    this.updateButtonVisibility();
  }

  updateButtonVisibility() {
    if (this.video.paused) {
      this.playButton.style.display = 'block';
      this.classList.add('video-paused');
      this.floatingTexts.forEach(text => {
        text.classList.remove(
          'section-with-floating-text__item--hidden-left',
          'section-with-floating-text__item--hidden-right'
        );
      });
    } else {
      this.playButton.style.display = 'none';
      this.classList.remove('video-paused');
      this.floatingTexts.forEach(text => {
        const direction = text.dataset.transform;
        if (direction === 'left') {
          text.classList.add('section-with-floating-text__item--hidden-left');
        } else if (direction === 'right') {
          text.classList.add('section-with-floating-text__item--hidden-right');
        }
      });
    }
  }

  disconnectedCallback() {
    this.playButton.removeEventListener('click', () => {
      this.video.play();
    });

    this.video.removeEventListener('click', () => {
      if (!this.video.paused) {
        this.video.pause();
      }
    });
  }
}

if (!customElements.get('floating-video')) {
  customElements.define('floating-video', FloatingVideo);
}
